{
  "version": 1,
  "asset_id": "81601f37-1e21-4c6d-ae11-86f05560e018",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/81601f37-1e21-4c6d-ae11-86f05560e018/egg-dark.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/81601f37-1e21-4c6d-ae11-86f05560e018/egg-dark.webp",
  "original_filename": "egg-dark.webp",
  "size": 6550,
  "content_type": "image/webp",
  "created_at": "2026-08-06T21:54:00Z"
}
